import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/@/components/ui/dialog';
import { Input } from 'src/@/components/ui/input';
import { FUNIL_DESIGN as D } from './FunilComponent.design';

export default function ModalOrigins({
  open,
  onClose,
  onSubmit,
  action,
  nome,
  changeNome,
}) {
  const { t } = useTranslation('settings');

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]" style={{ fontFamily: D.fontStack }}>
        <DialogHeader>
          <DialogTitle className={D.dialogTitle}>
            {action === 'Criar'
              ? t('funnel.origins.modal.createTitle', 'Criar origem de contato')
              : t('funnel.origins.modal.editTitle', 'Editar origem de contato')}
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-5 py-2">
          <div className={D.field}>
            <label className={D.label}>{t('labels.name', { ns: 'common' })}</label>
            <Input
              value={nome || ''}
              onChange={changeNome}
              placeholder={t('funnel.origins.modal.namePlaceholder', 'Digite o nome da origem')}
              className={D.input}
            />
            <p className={D.hint}>
              {t('funnel.origins.modal.nameHint', 'Ex.: Instagram, indicação, site — de onde o lead chegou.')}
            </p>
          </div>
        </div>
        <DialogFooter className={D.dialogFooter}>
          <button type="button" className={D.ghostButton} onClick={onClose}>
            {t('buttons.cancel', { ns: 'common' })}
          </button>
          <button type="button" className={D.primaryButton} onClick={onSubmit}>
            {action === 'Criar' ? t('buttons.create', { ns: 'common' }) : t('buttons.save', { ns: 'common' })}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
